import React from 'react';

import NCredito from 'components/Tvendo/Sale/Operations/NCredito/List';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <NCredito
      title="normal"
      type="NCN"
      permission={{
        show: 1,
        store: ConstantPermissions.SALE_CREDIT_NOTE_STORE
      }}
    />
  );
}
